import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconClose from '../IconClose';
import IconSearch from '../IconSearch';
import { ENTER_KEY } from '../../../consts';

import styles from './index.scss';

// hack for iphone
export function focusMobileInput() {
    const el = document.querySelector(`.${styles.mobileSearchArea__field}`);
    if (el) {
        el.focus();
        el.select();
        // this is to make blinking cursor appear on iphone
        setTimeout(() => {
            el.click();
        }, 0);
    }
}

class MobileSearchArea extends Component {
    state = {
        isFocused: false,
    };

    componentDidMount() {
        this.setState({ isFocused: true });

        document.addEventListener('mousedown', this.handleEventOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleEventOutside);
    }

    handleInputChange = event => {
        this.props.onChange(event.target.value);
    };

    handleInputClear = () => {
        focusMobileInput();
        this.props.onClear();
        this.props.addPopularSearches();
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleKeyPress = event => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === ENTER_KEY) {
            this.props.redirectTo();
        }
    };

    handleInputFocus = ev => {
        ev.preventDefault();

        if (ev.currentTarget === document.activeElement) {
            this.setState({ isFocused: true });
        }
    };

    handleInputClick = () => {
        this.inputNode.focus();
    };

    handleEventOutside = ev => {
        if (
            ev.target !== this.searchInputWrapMobileRef &&
            !this.searchInputWrapMobileRef.contains(ev.target)
        ) {
            this.setState({ isFocused: false });
        }
    };

    render() {
        const { isFocused } = this.state;
        const { inputValue, redirectTo, translationsMap } = this.props;

        const mobileSearchAreaStyles = classNames({
            [styles.mobileSearchArea]: true,
            [styles.visible]: true,
        });
        const mobileSearchAreaCancelStyles = classNames({
            [styles.mobileSearchArea__button]: true,
            [styles.mobileSearchArea__button_cancel]: true,
        });
        const mobileSearchAreaClearStyles = classNames({
            [styles.mobileSearchArea__button]: true,
            [styles.mobileSearchArea__button_clear]: true,
        });
        const mobileSearchSubmit = classNames({
            [styles.mobileSearchArea__submit]: true,
            'analytics-navigation': true,
        });
        const searchInputStyles = classNames({
            [styles.mobileSearchArea__field]: true,
            'analytics-input': true,
        });
        return (
            <div className={styles.mobileSearchAreaWrap}>
                <div className={mobileSearchAreaStyles}>
                    <div className={styles.mobileSearchArea__form}>
                        <div
                            className={styles.mobileSearchArea__fieldWrap}
                            ref={searchInputWrapMobile => {
                                this.searchInputWrapMobileRef = searchInputWrapMobile;
                                return null;
                            }}
                        >
                            <button
                                className={mobileSearchSubmit}
                                type="button"
                                onClick={redirectTo}
                            >
                                <IconSearch />
                            </button>
                            <input
                                className={searchInputStyles}
                                placeholder={translationsMap['search.fss.label.searchBox']}
                                value={inputValue}
                                onInput={this.handleInputChange}
                                onKeyPress={this.handleKeyPress}
                                onFocus={this.handleInputFocus}
                                ref={inputNode => {
                                    this.inputNode = inputNode;
                                    return null;
                                }}
                            />
                            {inputValue.length && isFocused ? (
                                <button
                                    className={mobileSearchAreaClearStyles}
                                    onClick={this.handleInputClear}
                                >
                                    <IconClose />
                                </button>
                            ) : null}

                            <div className={styles.mobileSearchArea__cancelWrap}>
                                <button
                                    className={mobileSearchAreaCancelStyles}
                                    onClick={this.handleCancel}
                                >
                                    {translationsMap.cancel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MobileSearchArea.propTypes = {
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
    translationsMap: PropTypes.object.isRequired,
    redirectTo: PropTypes.func.isRequired,
    addPopularSearches: PropTypes.func.isRequired,
};

export default MobileSearchArea;
